
















import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import APP_UTILITIES from '@/utilities/commonFunctions';
import UIkit from 'uikit';

@Component
export default class MobileDiscountTooltip extends Vue {
  @PropSync('discountName', { type: String, required: true }) discountNameSync!: string;
  @PropSync('tooltipDescription', { type: String, required: true }) tooltipDescriptionSync!: string;
  @PropSync('isMultiParticipantDiscount', { type: String, required: true }) isMultiParticipantDiscountSync!: boolean;
  @Prop({ type: Boolean, default: false }) isMultiParticipantDiscount!: boolean;

  tooltipId: string = '';

  created() {
    this.tooltipId = APP_UTILITIES.generateRandomAlphanumericId(10);
  }

  beforeDestroy() {
    UIkit.modal(`#${this.tooltipId}`).hide();
  }

}
